import { render, staticRenderFns } from "./ViewReport.vue?vue&type=template&id=72ec68ca&scoped=true&"
import script from "./ViewReport.vue?vue&type=script&lang=js&"
export * from "./ViewReport.vue?vue&type=script&lang=js&"
import style0 from "./ViewReport.vue?vue&type=style&index=0&id=72ec68ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec68ca",
  null
  
)

export default component.exports